import React from "react";
import { CCard, CCardBody } from "@coreui/react";

function ThankYou() {
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh", background: "#f5f7fa" }}>
      <CCard style={{ width: "500px" }}>
        <CCardBody className="text-center p-5">
          <div style={{ fontSize: 64, marginBottom: 16 }}>✓</div>
          <h3 className="mb-3">Thank You!</h3>
          <p className="text-muted mb-0">
            Your payment transaction details have been received successfully.
          </p>
        </CCardBody>
      </CCard>
    </div>
  );
}

export default ThankYou;
